import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { HippaComplianceService } from 'src/app/services/hippa-compliance.service';

@Component({
  selector: 'app-add-hippa-compliance',
  templateUrl: './add-hippa-compliance.component.html',
  styleUrls: ['./add-hippa-compliance.component.css'],
})
export class AddHippaComplianceComponent implements OnInit {
  @Output() submitAction = new EventEmitter<any>();

  parent: string;
  whohadproblems: string[] = ['Father', 'Mother'];
  id = 0;
  isSuccess = false;
  Frm: FormGroup;
  constructor(
    private fb: UntypedFormBuilder,
    private hippaComplianceService: HippaComplianceService,
    private route: ActivatedRoute,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((res) => {
      this.id = res['id'];
    });

    this.Frm = this.fb.group({
      PatientId: this.id,
      PhoneEmailTextConsent: [false],
      LeaveVoiceMessageConsent: [false],
      ConsetToDiscussMedicalConditionWithFamilyMember: [false],

      AuthorizedFamilyMemberName: [''],
      PatientName: ['', Validators.required],
      // Signauture: ['', Validators.required],
    });
  }

  get PatientId() {
    return this.Frm.get('PatientId');
  }

  get PhoneEmailTextConsent() {
    return this.Frm.get('PhoneEmailTextConsent');
  }
  get LeaveVoiceMessageConsent() {
    return this.Frm.get('LeaveVoiceMessageConsent');
  }
  get ConsetToDiscussMedicalConditionWithFamilyMember() {
    return this.Frm.get('ConsetToDiscussMedicalConditionWithFamilyMember');
  }

  get AuthorizedFamilyMemberName() {
    return this.Frm.get('AuthorizedFamilyMemberName');
  }

  get PatientName() {
    return this.Frm.get('PatientName');
  }

  get Signauture() {
    return this.Frm.get('Signauture');
  }

  formSubmit() {
    let body = {
      ...this.Frm.value,
      Signauture: this.signatureImg,
    };
    this.hippaComplianceService
      .registerHippaCompliance(body)
      .subscribe((res) => {
        this.isSuccess = true;
        this.Frm.reset();
        this.submitAction.emit('');
      });
  }

  @ViewChild('signPad', { static: false })
  signPad!: ElementRef<HTMLCanvasElement>;
  @Output() signatureSaved = new EventEmitter();
  private signatureImg?: string;
  private sigPadElement: any;
  private context: any;
  private isDrawing!: boolean;

  public ngAfterViewInit(): void {
    this.sigPadElement = this.signPad.nativeElement;
    this.context = this.sigPadElement.getContext('2d');
    this.context.strokeStyle = '#000';
  }

  onMouseDown(e: any): void {
    // The mouse button is clicked, which means the start of drawing the signature
    this.isDrawing = true;
    const coords = this.relativeCoords(e);
    this.context.moveTo(coords.x, coords.y);
  }

  @HostListener('document:mouseup', ['$event'])
  onMouseUp(e: any): void {
    // The mouse button is released, so this means the end of drawing the signature
    this.isDrawing = false;
  }

  onMouseMove(e: any): void {
    e.preventDefault();

    if (this.isDrawing) {
      // if we're not drawing we need to ignore the events
      const coords = this.relativeCoords(e);
      this.context.lineTo(coords.x, coords.y);
      this.context.stroke();
    }
  }

  clearSignature(e): void {
    e.preventDefault;

    this.signatureImg = undefined;
    this.context.clearRect(
      0,
      0,
      this.sigPadElement.width,
      this.sigPadElement.height
    );
    this.context.beginPath();
  }

  saveSignature(e): void {
    e.preventDefault;
    this.signatureImg = this.sigPadElement.toDataURL('image/png');

    this.signatureSaved.emit(this.signatureImg);
    // console.log('bite', this.signatureImg);
  }

  private relativeCoords(event: any): { x: number; y: number } {
    const bounds = event.target.getBoundingClientRect();
    const cords = {
      clientX: event.clientX || event.changedTouches[0].clientX,
      clientY: event.clientY || event.changedTouches[0].clientY,
    };
    const x = cords.clientX - bounds.left;
    const y = cords.clientY - bounds.top;
    return { x, y };
  }
}
